import React,{useState} from 'react'
import { MultiLevelSidebar } from '../Components/Layout/Sidebar'
import DailyForm from '../Components/Daily/DailyForm'
import { getDownloadURL } from 'firebase/storage'
import {
    ref as storageRef,
    uploadBytesResumable,
    listAll,
  } from "firebase/storage";
  import { ref, onValue, get,set,push,update} from "firebase/database";
import { db, storage } from '../firebase.config';
import { addDoc, collection } from 'firebase/firestore';
const AddDaily = () => {
    const [propertyName, setPropertyName] = useState("")
    const [propertyStartingPrice, setPropertyStartingPrice] = useState("")
    const [propertyLocation, setPropertyLocation] = useState("")
    const [propertyMap, setPropertyMap] = useState("")
    const [propertyImages, setPropertyImages] = useState([])
    const [propertyCoverImages, setPropertyCoverImages] = useState([])
    const [propertyDescription, setPropertyDescription] = useState("")
    const [youtubeVideo, setYoutubeVideo] = useState("")
    const [imageUrl, setImageUrl] = useState("")
    const [propertyType, setPropertyType] = useState("")
    const [propertyDescriptionTitle, setPropertyDescriptionTitle] = useState("")
    const [rooms, setRooms] = useState([])
    const [singleRoom, setSingleRoom] = useState({
        roomTitle:"",
        roomImage:"",
        roomContent:""
    })
    const [roomImageUrl, setRoomImageUrl] = useState("")
    const addImage = (e) =>{
        e.preventDefault()
   const file = e.target[0]?.files[0]
   if (!file) return;
   const storeRef = storageRef(storage, `files/${file.name}`);
   const uploadTask = uploadBytesResumable(storeRef, file);

   uploadTask.on("state_changed",
     (snapshot) => {
       
     },
     (error) => {
       alert(error);
     },
     () => {
       getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
         setImageUrl(downloadURL)
         setPropertyImages([...propertyImages,downloadURL])
         console.log(downloadURL)
       });
     }
   );
   }
   const addCoverImage = (e) =>{
    e.preventDefault()
const file = e.target[0]?.files[0]
if (!file) return;
const storeRef = storageRef(storage, `files/${file.name}`);
const uploadTask = uploadBytesResumable(storeRef, file);

uploadTask.on("state_changed",
 (snapshot) => {
   
 },
 (error) => {
   alert(error);
 },
 () => {
   getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
     setImageUrl(downloadURL)
     setPropertyCoverImages([...propertyCoverImages,downloadURL])
     console.log(downloadURL)
   });
 }
);
}
   const addRoomImage = (e) =>{
    e.preventDefault()
   const file = e.target[0]?.files[0]
   if (!file) return;
   const storeRef = storageRef(storage, `files/${file.name}`);
   const uploadTask = uploadBytesResumable(storeRef, file);

   uploadTask.on("state_changed",
     (snapshot) => {
       
     },
     (error) => {
       alert(error);
     },
     () => {
       getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
         setRoomImageUrl(downloadURL)
         setSingleRoom({...singleRoom,roomImage:downloadURL})
         console.log(downloadURL)
       });
     }
   );
   }
   const handleAddProperty = () =>{
    const date = new Date()
    addDoc(collection(db, "dailyProperty"),{
       name: propertyName,
       price: propertyStartingPrice,
       location: propertyLocation,
       map: propertyMap,
       images: propertyImages,
       description: propertyDescription,
       type: propertyType,
       youtubeId: youtubeVideo,
       coverImages:propertyCoverImages,
       rooms:rooms,
       propertyDescriptionTitle:propertyDescriptionTitle,
       createdAt:date
    })
    setPropertyName("")
    setPropertyDescription("")
    setPropertyStartingPrice("")
    setPropertyImages([])
    setImageUrl("")
    setPropertyMap("")
    setYoutubeVideo("")
    setPropertyType("")
    setPropertyLocation("")
    setPropertyCoverImages([])
    setSingleRoom({
        roomTitle:"",
        roomImage:"",
        roomContent:""
    })
    setRoomImageUrl("")
    setRooms([])
   }
  return (
    <div className='bg-gray-200 ' >
    <MultiLevelSidebar />
    <DailyForm propertyName={propertyName}
         setPropertyName={setPropertyName}
         propertyType={propertyType}
         setPropertyType={setPropertyType}
         propertyLocation={propertyLocation}
         setPropertyLocation={setPropertyLocation}
         propertyStartingPrice={propertyStartingPrice}
         setPropertyStartingPrice={setPropertyStartingPrice}
         propertyCoverImages={propertyCoverImages}
         setPropertyCoverImages={setPropertyCoverImages}
         addCoverImage={addCoverImage}
         propertyMap={propertyMap}
         setPropertyMap={setPropertyMap}
         youtubeVideo={youtubeVideo}
         setYoutubeVideo={setYoutubeVideo}
          propertyDescription={propertyDescription}
           setPropertyDescription={setPropertyDescription}
            imageUrl={imageUrl}
            rooms={rooms}
            singleRoom={singleRoom} 
            setSingleRoom={setSingleRoom}
            setRooms={setRooms}
            addRoomImage={addRoomImage}
            roomImageUrl={roomImageUrl}
             setImageUrl={setImageUrl}
            addImage={addImage}
             propertyImages={propertyImages}
             handleAddProperty={handleAddProperty}
              setPropertyImages={setPropertyImages}
              propertyDescriptionTitle={propertyDescriptionTitle}
              setPropertyDescriptionTitle={setPropertyDescriptionTitle} />
    </div>
  )
}

export default AddDaily